import Layout from "../../Components/Layout/Layout";
import VehiclesNavigation from "../../Navigation/VehiclesNavigation";
import FluentGrid from "../../Components/FluentGrid";
import { KpisGroup, ValidationKpisQuery, VehicleValidationKpis, WorkItemType } from "../../system/Domain";
import { useState } from "react";
import KpisGroupTile from "../../Components/KpisGroupTile";
import axios, { AxiosRequestConfig } from "axios";
import useAxiosEffect from "../../system/useAxiosEffect";
import { CircularProgress } from "@mui/material";
import { useDispatch } from "react-redux";
import { setWorkSession } from "../../system/reducers/workSessions/actions";
import { axiosDownload } from "../../system/axiosDownload";
import moment from "moment/moment";
import VehicleValidationDashboardSidebar from "./Validation/VehicleValidationDashboardSidebar";

export interface ValidationSlaQuery {
	dateFrom: string
}

const VehicleValidationDashboard = () => {
	const dispatch = useDispatch();
	const [vehicleValidationKpis, setVehicleValidationKpis] = useState<VehicleValidationKpis>();
	const [query, setQuery] = useState<ValidationSlaQuery>({
		dateFrom: moment().add(-1,'months').startOf('d').toISOString(true)
	});

	const loadValidationKpis = async (axiosConfig: AxiosRequestConfig = {}) => {
		const { data } = await axios.get<VehicleValidationKpis>(`/api/kpis/vehicles/validation`, axiosConfig);

		setVehicleValidationKpis(data);
	};

	useAxiosEffect(loadValidationKpis, []);

	const startSalesKpisSession = async (group: KpisGroup<ValidationKpisQuery>) => {
		let workItemType: WorkItemType = "Validation";
		const { data: workSession } = await axios.post(`/api/vehicles/remarketing/validation/kpis/work-sessions`, {
			title: group.name,
			workItemType,
			query: group.query
		});

		if (workSession) {
			dispatch(setWorkSession(workSession));
		}
	};

	const exportSalesKpis = async (group: KpisGroup<ValidationKpisQuery>) => {
		const response = await axios.post(`/api/vehicles/remarketing/validation/kpis/export`, group.query, {
			responseType: "blob"
		});

		axiosDownload(response, `${moment().format("YYYY-MM-DD")} ${group.name}.xlsx`);
	};

	return (
		<Layout
			title="Validierungsdashboard"
			navigation={<VehiclesNavigation />}
			sidebar={<VehicleValidationDashboardSidebar query={query} setQuery={setQuery} />}
		>
			{!vehicleValidationKpis && (
				<CircularProgress size={48} />
			)}
			{vehicleValidationKpis && (
				<FluentGrid itemWidth={350} itemGap={6}>
					<KpisGroupTile group={vehicleValidationKpis.koopDekra} startSession={startSalesKpisSession} exportKpis={exportSalesKpis} />
					<KpisGroupTile group={vehicleValidationKpis.koopMacadam} startSession={startSalesKpisSession} exportKpis={exportSalesKpis} />
					<KpisGroupTile group={vehicleValidationKpis.aldLegacyDekra} startSession={startSalesKpisSession} exportKpis={exportSalesKpis} />
					<KpisGroupTile group={vehicleValidationKpis.aldLegacyMacadam} startSession={startSalesKpisSession} exportKpis={exportSalesKpis} />
					<KpisGroupTile group={vehicleValidationKpis.lpLegacyDekra} startSession={startSalesKpisSession} exportKpis={exportSalesKpis} />
					<KpisGroupTile group={vehicleValidationKpis.lpLegacyMacadam} startSession={startSalesKpisSession} exportKpis={exportSalesKpis} />
					<KpisGroupTile group={vehicleValidationKpis.businessPartnerDekra} startSession={startSalesKpisSession} exportKpis={exportSalesKpis} />
					<KpisGroupTile group={vehicleValidationKpis.businessPartnerMacadam} startSession={startSalesKpisSession} exportKpis={exportSalesKpis} />
				</FluentGrid>
			)}
		</Layout>
	);
};

export default VehicleValidationDashboard;
